import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetImageComponent } from "../Components/WidgetImageComponent";
import { PopupImageComponent } from "../Popups/PopupImageComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { BooleanLinkTypes } from "../../../Pages/Measure/Dependencies/ContentBooleanLink";

export class WidgetImageProps {
    public title: LanguageString;
    public image: string;

    constructor() {
        this.title = new LanguageString();
        this.image = "";
    }
}

export class WidgetImage extends WidgetBase {
    props: WidgetImageProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetImageProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Image;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetImageComponent({
            widget: this,
        });
        return this.component.render();
    }

    showImage(): HTMLImageElement {
        if (this.props.image && this.checkImage()) {
            let img = document.createElement("img");
            /*img.setAttribute("class", "img-thumbnail");*/
            img.setAttribute("src", app.resolveUrl("~/custom/widget/" + this.props.image));
            return img;
        } else {
            this.props.image = "";
            return null;
        }
    }

    checkImage(): boolean {
        let exist: boolean = true;
        $.ajax({
            type: "GET",
            url: app.resolveUrl(`~/api/widget/checkWidgetImage/${this.props.image}`),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            async: false,
            success: (response) => {
                exist = response.exist;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });

        return exist;
    }

    showPopup(): void {
        let popup = new PopupImageComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}